import createQueryStore from './createQueryStore';

const store = createQueryStore('subscriptions');

export default store.reducer;
export const actions = store.actions;
export const useSubscriptionsStore = store.useStore;
